import { render, staticRenderFns } from "./ConfigKibanaDiscover.vue?vue&type=template&id=6e2a4c9a"
import script from "./ConfigKibanaDiscover.vue?vue&type=script&lang=js"
export * from "./ConfigKibanaDiscover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports